import { Injectable } from '@angular/core';

import { EmailAddress } from '../../models/email-address';

import { BackendBaseService } from '../backend-base.service';
import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class EmailAddressService extends BackendBaseService {
  url = 'email_addresses';

  constructor(public httpClient: HttpClientService) {
    super(httpClient);
  }

  /**
   * DELETE action for Email Address resource
   * @param  {number}       id address id
   * @return {Promise<any>}    Response of destroy
   */
  delete(id: number, angular: string = '1'): Promise<any> {
    return this.httpClient.delete(`${this.url}/${id}.json?angular=${angular}`);
  }

  /**
   * CREATE and UPDATE actions for Email Address resource
   * @param  {PhoneNumber} phone_number Email Address to be saved
   * @return {Promise<any>} Save response
   */
  save(email_address: EmailAddress): Promise<any> {
    return super.save({
      contact_id: email_address.contact_id,
      email_address: email_address,
      id: email_address.id
    });
  }

  /**
   * Update positions of Email Addresss of a contact
   * @param  {number}           contactId Contact id
   * @param  {Array<number> =         []}          email_address_ids Email Address ids in order
   * @return {Promise<any>}               Server response
   */
  updatePositions(contactId: number, email_address_ids: Array<number> = []): Promise<any> {
    return this.httpClient.put(`${this.url}/update_positions.json`, { contact_id: contactId, email_address_ids: email_address_ids });
  }
}
